import { useState } from "react";
import { toast } from "sonner";
import api from "@/lib/api";

const CATS = [
    { id: "events", label: "Events" },
    { id: "casting", label: "Casting" },
    { id: "series", label: "Series" },
    { id: "partnerships", label: "Partnerships" },
    { id: "community", label: "Community" },
];

export default function NewsletterSignup() {
    const [email, setEmail] = useState("");
    const [phone, setPhone] = useState("");
    const [sms, setSms] = useState(false);
    const [interests, setInterests] = useState(["events", "community"]);
    const [busy, setBusy] = useState(false);

    const toggle = (id) =>
        setInterests((s) => (s.includes(id) ? s.filter((x) => x !== id) : [...s, id]));

    const submit = async (e) => {
        e.preventDefault();
        if (!email) {
            toast.error("Please enter an email");
            return;
        }
        setBusy(true);
        try {
            await api.post("/subscribe", {
                email,
                phone: phone || null,
                interests,
                sms_consent: sms,
            });
            toast.success("You're in. Watch your inbox.");
            setEmail("");
            setPhone("");
            setSms(false);
        } catch (err) {
            toast.error("Something went wrong. Try again.");
        } finally {
            setBusy(false);
        }
    };

    return (
        <form onSubmit={submit} data-testid="newsletter-form" className="space-y-6">
            <div className="grid sm:grid-cols-2 gap-6">
                <input
                    type="email"
                    required
                    className="input-line"
                    placeholder="Email address"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    data-testid="newsletter-email"
                />
                <input
                    type="tel"
                    className="input-line"
                    placeholder="Mobile (optional, for SMS)"
                    value={phone}
                    onChange={(e) => setPhone(e.target.value)}
                    data-testid="newsletter-phone"
                />
            </div>
            <div className="flex flex-wrap gap-3">
                {CATS.map((c) => (
                    <button
                        type="button"
                        key={c.id}
                        onClick={() => toggle(c.id)}
                        className={`chip ${interests.includes(c.id) ? "active" : ""}`}
                        data-testid={`newsletter-interest-${c.id}`}
                    >
                        {c.label}
                    </button>
                ))}
            </div>
            <label className="flex items-start gap-3 text-xs text-[color:var(--cream-muted)]">
                <input
                    type="checkbox"
                    checked={sms}
                    onChange={(e) => setSms(e.target.checked)}
                    className="mt-1 accent-[color:var(--gold)]"
                    data-testid="newsletter-sms-consent"
                />
                <span>
                    I agree to receive occasional SMS from Mrs.Black(In)Love about my selected categories. Reply STOP to opt out.
                </span>
            </label>
            <button
                type="submit"
                disabled={busy}
                className="btn-gold"
                data-testid="newsletter-submit"
            >
                {busy ? "Sending…" : "Join the list"}
            </button>
        </form>
    );
}
